module.exports = __webpack_public_path__ + "img/wave-triangle.37d48db3.svg";